// extracted by mini-css-extract-plugin
export default {"ProductPageApp":"G3_rYb","productPageApp":"G3_rYb"};